// __BUILD_TIME__ wird in vite.config.ts via define gesetzt (JSON.stringify(new Date().toISOString())).
// Konsum-Muster wie in pages/wiki/wikiArticles.ts (lokale declare + Fallback für Tests/SSR).
declare const __BUILD_TIME__: string | undefined

export const BUILD_TIME: string =
  typeof __BUILD_TIME__ !== 'undefined' && __BUILD_TIME__ ? __BUILD_TIME__ : ''

export function formatBuildDate(iso: string): string {
  return iso.slice(0, 10)
}

export function footerBuildLabel(iso: string, isDemo: boolean): string {
  const date = formatBuildDate(iso)
  const mode = isDemo ? 'Demo-Modus' : 'Live-Modus'
  return date ? `Build ${date} · ${mode}` : mode
}
